import { useQuery } from '@tanstack/react-query'

import client from '@/shared/apis/client'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { KasanAnalysisReportResponse } from '../types'

// 算定分析レポート取得。月次バッチ成果物のためpolling不要・staleTime長め
export const useKasanAnalysisReportQuery = () => {
  const query = useQuery({
    queryKey: queryKeys.kasanAnalysis.report(),
    queryFn: async (): Promise<KasanAnalysisReportResponse> => {
      const response = await client.get<KasanAnalysisReportResponse>(
        '/api/kasan-analysis/report/'
      )
      return response.data
    },
    staleTime: 1000 * 60 * 60, // 1時間
  })

  return {
    report: query.data?.report ?? null,
    isLoading: query.isLoading,
    error: query.error ?? null,
  }
}
